export function parseJwt<T = any>(token: string): T | null {
  try {
    const jwtPayload = JSON.parse(atob(token.split('.')[1]));
    return jwtPayload as T;
  } catch (e) {
    console.log('Failed to parse JWT', e.message);
    return null;
  }
}
